
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 15","xmlns":"http://www.w3.org/2000/svg","fill":"#FFF"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.97 14.824c-.605-1.094-1.07-1.898-1.396-2.412l-.517-.81-.391-.596C1.813 9.678.924 8.58 0 7.715c.527-.436 1.019-.654 1.475-.654.56 0 1.058.205 1.494.615.436.41.986 1.191 1.65 2.344A40.04 40.04 0 017.5 3.037C8.145 1.84 8.72 1.034 9.224.62 9.728.207 10.397 0 11.23 0c.443 0 .99.068 1.641.205A15.707 15.707 0 008.857 5.01c-1.002 1.855-2.298 5.127-3.886 9.814z"}})])
          )
        }
      }
    